export default (to, from, next) => {
    setTimeout(() => document.getElementById('listTop').scrollIntoView({
        top: 0,
        behavior: 'smooth',
    }), 1100);

    next();
};
